import React, { useState, useEffect } from "react";
import { Button, Table } from "react-bootstrap";
import Swal from "sweetalert2";
import "bootstrap/dist/css/bootstrap.min.css";
import NotificationModel from "./NotificationModal ";
import SendNotificationModel from "./SendNotificationModal";
import SendAllNotificationModal from "./SendAllModel";
import AppversionNotifyModel from "./AppversionNotifyModal";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const Notifications = () => {
  const [showModal, setShowModal] = useState(false);
  const [sendNotificationModal, setSendNotificationModal] = useState(false);
  const [sendAllNotificationModal, setSendAllNotificationModal] =
    useState(false);
  const [appVersionNotifyModal, setAppVersionNotifyModal] = useState(false);
  const [editingNotification, setEditingNotification] = useState(false);
  const [currentNotification, setCurrentNotification] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [notificationData, setNotificationData] = useState({
    title: "",
    description: "",
    url: "",
    imageUrl: "",
  });
  const [sendNotificationData, setSendNotificationData] = useState({
    customerId: "",
    notificationId: "",
  });
  const [sendAllNotificationData, setSendAllNotificationData] = useState({
    notificationId: "",
  });
  const API_URL = process.env.REACT_APP_API_URL;
  const Mobile_Url = process.env.REACT_APP_MOBILE_API_URL;

  const token = localStorage.getItem("authToken");

  const [showScrollButton, setShowScrollButton] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      try {
        const decoded = jwtDecode(token);
        const role = decoded?.role;
        if (role !== "admin" && role !== "manager") {
          navigate("/dashboard");
        }
      } catch (err) {
        console.error("Invalid token:", err);
        navigate("/dashboard");
      }
    } else {
      navigate("/dashboard");
    }
  }, [navigate, token]);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollButton(window.scrollY > 300);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/notifications`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        // Filter out unwanted titles
        const excludedTitles = [
          "Complaint Resolved",
          "Complaint Submitted",
          "Request Submitted",
          "Request Resolved",
          "Feedback Submitted",
          "Hydration Reminder 💧",
          "Assist Submitted",
        ];

        const filteredNotifications = response.data.filter(
          (notification) => !excludedTitles.includes(notification.title),
        );

        setNotifications(filteredNotifications);
      } catch (error) {
        console.error("Error fetching notifications:", error);
        Swal.fire({
          icon: "error",
          title: "Failed to fetch notifications",
          text: "There was an issue fetching the notifications. Please try again.",
        });
      }
    };

    fetchNotifications();
  }, [token, API_URL]);

  const handleClose = () => {
    setNotificationData({
      title: "",
      description: "",
      url: "",
      imageUrl: "",
    });
    setShowModal(false);
    setEditingNotification(false);
    setCurrentNotification(null);
  };

  const handleShow = () => setShowModal(true);

  const handleSendNotificationClose = () => setSendNotificationModal(false);

  const handleSendNotificationShow = () => setSendNotificationModal(true);

  const handleSendAllNotificationShow = () => setSendAllNotificationModal(true);
  const handleSendAllNotificationClose = () =>
    setSendAllNotificationModal(false);

  const handleAppVersionNotifyClose = () => setAppVersionNotifyModal(false);
  const handleAppVersionNotifyShow = () => setAppVersionNotifyModal(true);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNotificationData({ ...notificationData, [name]: value });
  };

  const handleSave = async () => {
    const { title, description } = notificationData;
    const url = notificationData.url.trim() || null;
    const imageUrl = notificationData.imageUrl.trim() || null;

    try {
      if (editingNotification && currentNotification) {
        await axios.put(
          `${API_URL}/api/notifications/${currentNotification.id}`,
          { title, description, url, imageUrl },
          { headers: { Authorization: `Bearer ${token}` } },
        );

        const updatedNotifications = notifications.map((notification) =>
          notification.id === currentNotification.id
            ? { ...notification, ...notificationData }
            : notification,
        );
        setNotifications(updatedNotifications);
        Swal.fire({
          icon: "success",
          title: "Notification Updated!",
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        const response = await axios.post(
          `${API_URL}/api/notifications`,
          { title, description, url, imageUrl },
          { headers: { Authorization: `Bearer ${token}` } },
        );
        setNotifications([...notifications, response.data]);
        Swal.fire({
          icon: "success",
          title: "Notification Added!",
          showConfirmButton: false,
          timer: 1500,
        });
      }
      handleClose();
    } catch (error) {
      console.error("Error saving notification:", error);
      Swal.fire({
        icon: "error",
        title: "Failed to Save Notification",
        text: "There was an issue saving the notification. Please try again.",
      });
    }
  };

  const handleDeleteNotification = async (id) => {
    const confirmResult = await Swal.fire({
      title: "Are you sure?",
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (confirmResult.isConfirmed) {
      try {
        await axios.delete(`${API_URL}/api/notifications/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setNotifications(
          notifications.filter((notification) => notification.id !== id),
        );
        Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: "The notification has been deleted.",
          showConfirmButton: false,
          timer: 1500,
        });
      } catch (error) {
        console.error("Error deleting notification:", error);
        Swal.fire({
          icon: "error",
          title: "Failed to Delete Notification",
          text: "There was an issue deleting the notification. Please try again.",
        });
      }
    }
  };
  const handleAppversionNotify = async () => {
    // Implement the logic for App Version Notification Push here
    const { deviceType, url } = notificationData;
    if (!deviceType || !url) {
      Swal.fire({
        icon: "error",
        title: "Missing Fields",
        text: "Please provide both Device Type and URL.",
      });
      return;
    }
    try {
      const response = await axios.post(
        `${Mobile_Url}/api/AppVersion/AppVersionNotify`,
        { deviceType, url },
        { headers: { Authorization: `Bearer ${token}` } },
      );
      if (response.status === 202 || response.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Notification Sent!",
          text: "The notification has been successfully sent.",
        });
      } else {
        throw new Error(
          response.data?.message || "Unexpected response structure.",
        );
      }
    } catch (error) {
      console.error("Error sending notification:", error);
      Swal.fire({
        icon: "error",
        title: "Failed to Send Notification",
        text:
          error.response?.data?.message ||
          error.message ||
          "An unexpected error occurred.",
      });
    }
    handleAppVersionNotifyClose();
  };

  const handleSendNotification = async () => {
    const { customerId, notificationId } = sendNotificationData;
    if (!customerId || !notificationId) {
      Swal.fire({
        icon: "error",
        title: "Missing Fields",
        text: "Please provide both Customer ID and Notification ID.",
      });
      return;
    }
    try {
      const response = await axios.post(
        `${Mobile_Url}/api/FirebasePushNotifications/sendToUser`,
        null,
        {
          params: { CustomerId: customerId, notificationId },
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Notification Sent!",
          text: "The notification has been successfully sent.",
        });
        handleSendNotificationClose();
      } else {
        throw new Error(
          response.data?.message || "Unexpected response structure.",
        );
      }
    } catch (error) {
      console.error("Error sending notification:", error);
      Swal.fire({
        icon: "error",
        title: "Failed to Send Notification",
        text:
          error.response?.data?.message ||
          error.message ||
          "An unexpected error occurred.",
      });
    }
  };

  const handleSendNotificationChange = (e) => {
    const { name, value } = e.target;
    setSendNotificationData({ ...sendNotificationData, [name]: value });
  };

  const handleSendAllNotificationChange = (e) => {
    const { name, value } = e.target;
    setSendAllNotificationData({ ...sendAllNotificationData, [name]: value });
  };

  const handleSendAllNotification = async () => {
    const { notificationId } = sendAllNotificationData;
    if (!notificationId) {
      Swal.fire({
        icon: "error",
        title: "Missing Notification ID",
        text: "Please provide a Notification ID to send.",
      });
      return;
    }
    try {
      const response = await axios.post(
        `${Mobile_Url}/api/FirebasePushNotifications/sendToAllUsers`,
        null,
        {
          params: { notificationId },
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Notification Sent to All!",
          text: "The notification was successfully sent to all users.",
        });
        handleSendAllNotificationClose();
      } else {
        throw new Error(
          response.data?.message || "Unexpected response structure.",
        );
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Failed to Send Notification",
        text: error.response?.data?.message || error.message,
      });
    }
  };

  // --- FILTER OUT EXCLUDED NOTIFICATIONS ---
  const excludedPhrases = [
    "Complaint Resolved",
    "Complaint Submitted",
    "Request Submitted",
    "Request Resolved",
    "Feedback Submitted",
    "Hydration Reminder 💧",
    "Assist Submitted",
  ];
  // Filter out notifications with excluded phrases in their title (case-insensitive)
  const filteredNotifications = notifications.filter(
    (notification) =>
      !excludedPhrases.some((phrase) =>
        (notification.title || "").toLowerCase().includes(phrase.toLowerCase()),
      ),
  );

  return (
    <div>
      <h1 className="mb-4">Notifications</h1>
      <p>Manage your Notifications here.</p>
      <Button variant="primary" onClick={handleShow} className="me-3">
        Add New Notification
      </Button>
      <Button
        variant="secondary"
        onClick={handleSendNotificationShow}
        className="me-3"
      >
        Send Notification
      </Button>
      <Button
        variant="dark"
        onClick={handleSendAllNotificationShow}
        className="me-3"
      >
        Send Notification ALL
      </Button>
      <Button
        variant="dark"
        onClick={handleAppVersionNotifyShow}
        className="me-3"
      >
        App Version Notification Push
      </Button>

      <Table striped bordered hover className="mt-3">
        <thead>
          <tr>
            <th>Notification ID</th>
            <th>Title</th>
            <th>Description</th>
            <th>Image URL</th>
            <th>URL</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredNotifications.map((notification) => (
            <tr key={notification.id}>
              <td>{notification.id}</td>
              <td>{notification.title}</td>
              <td>{notification.description}</td>
              <td>
                {notification.imageUrl ? (
                  <img
                    loading="lazy"
                    src={notification.imageUrl}
                    alt={notification.title}
                    style={{ width: "100px", height: "auto" }}
                  />
                ) : (
                  "No image available"
                )}
              </td>
              <td>
                {notification.url ? (
                  <a
                    href={notification.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Visit Link
                  </a>
                ) : (
                  "No link available"
                )}
              </td>
              <td>
                {/* <Button 
                  variant="info" 
                  onClick={() => handleEditNotification(notification.id)}
                  className="me-2"
                >
                  Edit
                </Button> */}
                <Button
                  variant="danger"
                  onClick={() => handleDeleteNotification(notification.id)}
                >
                  Delete
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <NotificationModel
        show={showModal}
        handleClose={handleClose}
        handleChange={handleChange}
        handleSave={handleSave}
        notificationData={notificationData}
        editingNotification={editingNotification}
      />

      <SendNotificationModel
        show={sendNotificationModal}
        handleClose={handleSendNotificationClose}
        handleSendNotification={handleSendNotification}
        handleSendNotificationChange={handleSendNotificationChange}
        sendNotificationData={sendNotificationData}
        notifications={notifications}
      />

      <SendAllNotificationModal
        show={sendAllNotificationModal}
        handleClose={handleSendAllNotificationClose}
        handleSendAllNotification={handleSendAllNotification}
        handleChange={handleSendAllNotificationChange}
        sendAllNotificationData={sendAllNotificationData}
        notifications={notifications}
      />
      <AppversionNotifyModel
        show={appVersionNotifyModal}
        handleClose={handleAppVersionNotifyClose}
        handleChange={handleChange}
        handleSave={handleAppversionNotify}
        notificationData={notificationData}
        editingNotification={false}
      />

      {showScrollButton && (
        <Button
          className="position-fixed bottom-0 end-0 m-4"
          onClick={scrollToTop}
        >
          ↑ Top
        </Button>
      )}
    </div>
  );
};

export default Notifications;
